import Icon from "@components/new/Icon";
import { Title2 } from '@components/new/Typo';
import styles from "./MenuItem.module.scss";

export const MenuItem = ({ icon, title, onClick }: {
  icon?: string | React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  title: string;
  onClick: () => void;
}) => {
  return (
    <div
      className={styles.menuItem}
      onClick={onClick}
    >
      {icon ? (
        <Icon icon={icon} className={styles.icon} />
      ) : <span className={styles.icon} />}
      <Title2>{title}</Title2>
    </div>
  );
};
